<template>
  <div class="vue-template">
    <div class="jumbotron bg-gradient">
      <div class="container">
        <h1 class="display-4">
          Sign In
        </h1>
      </div>
    </div>
    <div class="container">
      <form @submit.prevent="userLogin">
        <div class="form-group">
          <label>Email address</label>
          <input
            type="email"
            class="form-control form-control-lg"
            v-model="user.email"
          />
        </div>

        <div class="form-group">
          <label>Password</label>
          <input
            type="password"
            class="form-control form-control-lg"
            v-model="user.password"
          />
        </div>

        <button type="submit" class="btn btn-dark btn-lg btn-block">
          Sign In
        </button>

        <p class="forgot-password text-right mt-2 mb-4">
          <router-link to="/forgot-password">Forgot password ?</router-link>
        </p>
      </form>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';

export default {
  data() {
    return {
      user: {
        email: '',
        password: '',
      },
    };
  },
  methods: {
    userLogin() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.user.email, this.user.password)
        .then(() => {
          this.$store.dispatch('setloggedInStatus', true);
          this.$router.push('/profil');
        })
        .catch(error => {
          alert(error.message);
        });
    },
  },
};
</script>
